import React from 'react'
import messageFeatureImg from '../../assets/message_feature.png'
import videoCallFeatureImg from '../../assets/video_call_feature.png'
const FeatureComponent = () => {
  return (
    <>
      <p className="firefly-features-header">もなかの機能</p>
      <div className="user-list-feature">
        <div className="user-list-description">
          <p className="title">
            今日の献立をコメントやメッセージ機能で相談して悩みを解決！
          </p>
          <p>
            画像や動画を添付することで、料理の見栄えが良くなるかも！
          </p>
        </div>
        <div className="user-list-feature-img">
          <img src={messageFeatureImg} />
        </div>
      </div>
      <div className="video-call-feature">
        <div className="video-call-feature-img">
          <img src={videoCallFeatureImg} />
        </div>
        <div className="video-call-description">
          <p className="title">
            ビデオ通話で料理風景を見せ合い！
          </p>
          <p>
            1人でしていた料理が楽しく料理することができます！
          </p>
        </div>
      </div>
    </>
  )
}
export default FeatureComponent